module.exports = __webpack_public_path__ + "static/Grupo 99-3f8b88760cc37219fcf29434eeafb5dc.svg";